// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b67fbdf4","578":"f3060a49","622":"ca383a6b","977":"0df568dd"}[chunkId] + ".chunk.js";
};